import * as React from 'react';

interface IButtonProps {
  as?: any;
  children: any;
  className?: string;
  href?: string;
  onClick?: () => void;
  style?: any;
  to?: string;
  'data-testid'?: string;
  type?: string;
  bg?: string;
  color?: string;
}

const Button: React.FunctionComponent<IButtonProps> = ({
  as = 'button',
  children,
  className = '',
  ...rest
}) => {
  const Component: any = { tag: as };
  return (
    <Component.tag
      className={`btn f6 br2 ${className}`}
      style={{ padding: '.625rem 1.5rem' }}
      {...rest}
    >
      {children}
    </Component.tag>
  );
};

export default Button;
